import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
interface ActionProps {
  handleClick?: () => void;
  icon?: string;
  title?: string;
  children?: any;
  iconC?: any;
  disabled?: boolean;
}

const ActionButton = (props: ActionProps) => {
  const { t } = useTranslation();
  const isDisabled = props.disabled || false;

  const handleClick = () => {
    props.handleClick && props?.handleClick();
  };
  return (
    <Grid
      sx={{
        cursor: isDisabled ? "not-allowed" : "pointer",
        marginLeft: "8px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid
        sx={{
          cursor: "pointer",
          marginLeft: "8px",
          display: "flex",
          alignItems: "center",
          color: isDisabled ? "#cccccc" : '#00000099',
          pointerEvents: isDisabled ? "none" : "auto",
        }}
        onClick={handleClick}
      >
        <i className={"icon iconfont " + props.icon}></i>
        {props.iconC}
        <span
          style={{
            fontSize: "14px",
            color: isDisabled ? "#cccccc" : "#75828A",
            marginLeft: "4px",
            cursor: isDisabled ? "not-allowed" : "pointer",
          }}
        >
          {props.title}
        </span>
      </Grid>
    </Grid>
  );
};
export default ActionButton;
